export const epidemiologico2025 = [
  {
    "id_semana":"Semana 1 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 1.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 1.jpg",
  },
  {
    "id_semana":"Semana 2 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 2.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 2.jpg",
  },
  {
    "id_semana":"Semana 3 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 3.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 3.jpg",
  },
  {
    "id_semana":"Semana 4 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 4.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 4.jpg",
  },
  {
    "id_semana":"Semana 5 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 5.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 5.jpg",
  },
  {
    "id_semana":"Semana 6 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 6.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 6.jpg",
  },
  {
    "id_semana":"Semana 7 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 7.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 7.jpg",
  },
  {
    "id_semana":"Semana 8 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 8.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 8.jpg",
  },
  {
    "id_semana":"Semana 9 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 9.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 9.jpg",
  },
  {
    "id_semana":"Semana 10 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 10.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 10.jpg",
  },
  {
    "id_semana":"Semana 11 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 11.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 11.jpg",
  },
  {
    "id_semana":"Semana 12 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 12.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 12.jpg",
  },
  {
    "id_semana":"Semana 13 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 13.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 13.jpg",
  },
  {
    "id_semana":"Semana 14 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 14.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 14.jpg",
  },
  {
    "id_semana":"Semana 15 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 15.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 15.jpg",
  },
  {
    "id_semana":"Semana 16 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 16.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 16.jpg",
  },
  {
    "id_semana":"Semana 17 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 17.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 17.jpg",
  },
  {
    "id_semana":"Semana 18 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 18.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 18.jpg",
  },
  {
    "id_semana":"Semana 19 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 19.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 19.jpg",
  },
  {
    "id_semana":"Semana 20 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 20.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 20.jpg",
  },
  {
    "id_semana":"Semana 21 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 21.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 21.jpg",
  },
  {
    "id_semana":"Semana 22 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 22.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 22.jpg",
  },
  {
    "id_semana":"Semana 23 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 23.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 23.jpg",
  },
  {
    "id_semana":"Semana 24 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 24.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 24.jpg",
  },
  {
    "id_semana":"Semana 25 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 25.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 25.jpg",
  },
  {
    "id_semana":"Semana 26 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 26.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 26.jpg",
  },
  {
    "id_semana":"Semana 27 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 27.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 27.jpg",
  },
  {
    "id_semana":"Semana 28 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 28.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 28.jpg",
  },
  {
    "id_semana":"Semana 29 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 29.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 29.jpg",
  },
  {
    "id_semana":"Semana 30 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 30.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 30.jpg",
  },
  {
    "id_semana":"Semana 31 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 31.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 31.jpg",
  },
  {
    "id_semana":"Semana 32 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 32.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 32.jpg",
  },
  {
    "id_semana":"Semana 33 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 33.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 33.jpg",
  },
  {
    "id_semana":"Semana 34 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 34.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 34.jpg",
  },
  {
    "id_semana":"Semana 35 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 35.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 35.jpg",
  },
  {
    "id_semana":"Semana 36 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 36.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 36.jpg",
  },
  {
    "id_semana":"Semana 37 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 37.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 37.jpg",
  },
  {
    "id_semana":"Semana 38 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 38.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 38.jpg",
  },
  {
    "id_semana":"Semana 39 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 39.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 39.jpg",
  },
  {
    "id_semana":"Semana 40 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 40.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 40.jpg",
  },
  {
    "id_semana":"Semana 41 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 41.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 41.jpg",
  },
  {
    "id_semana":"Semana 42 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 42.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 42.jpg",
  },
  {
    "id_semana":"Semana 43 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 43.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 43.jpg",
  },
  {
    "id_semana":"Semana 44 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 44.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 44.jpg",
  },
  {
    "id_semana":"Semana 45 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 45.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 45.jpg",
  },
  {
    "id_semana":"Semana 46 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 46.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 46.jpg",
  },
  {
    "id_semana":"Semana 47 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 47.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 47.jpg",
  },
  {
    "id_semana":"Semana 48 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 48.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 48.jpg",
  },
  {
    "id_semana":"Semana 49 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 49.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 49.jpg",
  },
  {
    "id_semana":"Semana 50 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 50.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 50.jpg",
  },
  {
    "id_semana":"Semana 51 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 51.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 51.jpg",
  },
  {
    "id_semana":"Semana 52 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 52.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 52.jpg",
  },
  {
    "id_semana":"Semana 53 - 2025",
    "file_url": "../../contenido/epidemiologia/2025/Boletin Semana 53.pdf",
    "img_url":"../../../contenido/epidemiologia/2025/Boletin Semana 53.jpg",
  },
]